<div class="center-align margin-top-20 margin-bottom-20" *ngIf="dataSource.data.length === 0 && networkCallInProgress">
    <mat-spinner [diameter]="35"></mat-spinner>
</div>
<div *ngIf="dataSource.data.length > 0">
    <mat-table [dataSource]="dataSource" matSort matSortActive="numberOfEmisOverdue" matSortDirection="desc"
        class="finzyfont margin-top-20 margin-bottom-20" multiTemplateDataRows>
        <ng-container matColumnDef="loanId">
            <mat-header-cell *matHeaderCellDef> Loan ID<br>(Rating)</mat-header-cell>
            <mat-cell *matCellDef="let element"> <span>
                    <span class="small-text">{{element.loanId}}</span> <br><span
                        class="small-text">({{element.rating}})</span>
                </span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="investmentInLoan">
            <mat-header-cell *matHeaderCellDef>Investment <br> in Loan</mat-header-cell>
            <mat-cell *matCellDef="let element">
                <app-indian-currency-formatter [amount]="element.investmentInLoan">
                </app-indian-currency-formatter>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="grossCashFlowReceivedBeforeRestructure">
            <mat-header-cell *matHeaderCellDef class="before-restructure-background"
                style="padding-bottom: 22px;padding-top: 12px;">Gross Cashflow Received
            </mat-header-cell>

            <mat-cell *matCellDef="let element" class="before-restructure-background">
                <app-indian-currency-formatter [amount]="element.grossCashFlowReceivedBeforeRestructure">
                </app-indian-currency-formatter>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="statusBeforeRestructure">
            <mat-header-cell *matHeaderCellDef class="before-restructure-background"
                style="padding-bottom: 39px;padding-top: 12px;"> Status
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="before-restructure-background"> <span>
                    <span>{{element.statusBeforeRestructure}}</span> <br><span
                        class="small-text">({{element.restructuringDate}})</span>
                </span></mat-cell>
        </ng-container>

        <!--        <ng-container matColumnDef="beforeRestructuring">-->
        <!--            <mat-header-cell *matHeaderCellDef style="padding-left: 226px" [attr.rowspan]="4">BEFORE RESTRUCTURING</mat-header-cell>-->
        <!--        </ng-container>-->

        <ng-container matColumnDef="restructuringDate">
            <mat-header-cell *matHeaderCellDef>Restructuring<br>Date</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.restructuringDate}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="upfrontPayment">
            <mat-header-cell *matHeaderCellDef>Upfront <br> Payment <br>Received <br> (if any)
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <app-indian-currency-formatter [amount]="element.upfrontPayment">
                </app-indian-currency-formatter>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="principalOutstandingPostRestructure">
            <mat-header-cell *matHeaderCellDef>Current <br>Principal <br>Outstanding
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <app-indian-currency-formatter [amount]="element.principalOutstandingPostRestructure">
                </app-indian-currency-formatter>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="principalWriteOffOrWriteBack">
            <mat-header-cell *matHeaderCellDef>Principal Write off / <br>Write back
                <app-tooltip placement="bottom">
                    <i class="info-icon material-icons" trigger>info_outline</i>
                    <div content style="max-width: 300px;">Negative value is a write off and positive value is a write
                        back.
                    </div>
                </app-tooltip>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <app-indian-currency-formatter [amount]="element.principalWriteOffOrWriteBack">
                </app-indian-currency-formatter>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="restructuredFirstEmiDate">
            <mat-header-cell *matHeaderCellDef>New EMI <br>Start Date <br>and Details</mat-header-cell>
            <mat-cell *matCellDef="let element"> <span>
                    <span>{{element.restructuredFirstEmiDate}}</span>
                    <br><span class="small-text">{{element.tenurePostRestructure}} M |
                        {{element.roiPostRestructure}}%</span>
                </span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="loanSanctionStatus">
            <mat-header-cell *matHeaderCellDef>Current Status
            </mat-header-cell>
            <mat-cell *matCellDef="let element">{{element.loanSanctionStatus}}
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="emptyColumn1">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="emptyColumn2">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="beforeRestructuring">
            <mat-header-cell *matHeaderCellDef class="before-restructure-background"
                style="padding-left: 51px;padding-right: 42px;text-align: center">
                BEFORE RESTRUCTURING
            </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="emptyColumn5">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="emptyColumn6">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="postRestructuring">
            <mat-header-cell *matHeaderCellDef style="padding-left: 51px;padding-right: 42px;text-align: center">POST
                RESTRUCTURING
            </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="emptyColumn9">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="emptyColumn10">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>
        <!--        <ng-container matColumnDef="beforeRestructuring">-->
        <!--            <th mat-header-cell *matHeaderCellDef-->
        <!--                [attr.colspan]="2">-->
        <!--                BEFORE RESTRUCTURING-->
        <!--            </th>-->
        <!--        </ng-container>-->
        <!--        <ng-container matColumnDef="postRestructuring">-->
        <!--            <th mat-header-cell *matHeaderCellDef-->
        <!--                [attr.colspan]="6">-->
        <!--                POST RESTRUCTURING-->
        <!--            </th>-->
        <!--        </ng-container>-->
        <ng-container matColumnDef="accordion_arrow">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element" style="justify-content: flex-end;max-width: 46px;">
                <mat-icon style="font-family: 'Material Icons';font-size: 18px;">{{element == expandedElement ?
                    'arrow_drop_up' : 'arrow_drop_down'}}
                </mat-icon>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
            <mat-cell *matCellDef="let element">
                <div class="accordion-element-detail" *ngIf="isMobile"
                    [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">

                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            Status
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <span>
                                <span>{{element.statusBeforeRestructure}}</span> <br><span
                                    class="small-text">({{element.restructuringDate}})</span>
                            </span>
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            Restructuring<br>Date
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            {{element.restructuringDate}}
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            Upfront <br> Payment <br>Received <br> (if any)
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <app-indian-currency-formatter [amount]="element.upfrontPayment">
                            </app-indian-currency-formatter>
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            Current <br>Principal <br>Outstanding
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <app-indian-currency-formatter [amount]="element.principalOutstandingPostRestructure">
                            </app-indian-currency-formatter>
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            Principal Write off / <br>Write back <app-tooltip placement="bottom">
                                <i class="info-icon material-icons" trigger>info_outline</i>
                                <div content style="max-width: 300px;">Negative value is a write off and positive value
                                    is a
                                    write
                                    back.
                                </div>
                            </app-tooltip>
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <app-indian-currency-formatter [amount]="element.principalWriteOffOrWriteBack">
                            </app-indian-currency-formatter>
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            New EMI <br>Start Date <br>and Details
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <span>
                                <span>{{element.restructuredFirstEmiDate}}</span>
                                <br><span class="small-text">{{element.tenurePostRestructure}} M |
                                    {{element.roiPostRestructure}}%</span>
                            </span>
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            Current Status
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            {{element.loanSanctionStatus}}
                        </div>
                    </div>
                </div>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="isMobile? []:['emptyColumn1','emptyColumn2','beforeRestructuring','emptyColumn5',
        'emptyColumn6', 'postRestructuring','emptyColumn9','emptyColumn10']"></mat-header-row>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let element; columns: displayedColumns;" class="accordion-element-row"
            [class.accordion-expanded-row]="expandedElement === element"
            (click)="expandedElement = expandedElement === element ? null : element"></mat-row>
        <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="accordion-detail-row">
        </mat-row>
    </mat-table>
</div>